/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

export type AgentRunListStatus =
  (typeof AgentRunListStatus)[keyof typeof AgentRunListStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AgentRunListStatus = {
  analyzing_trends: "analyzing_trends",
  awaiting_approval: "awaiting_approval",
  cancelled: "cancelled",
  completed: "completed",
  creating_playlist: "creating_playlist",
  failed: "failed",
  generating_description: "generating_description",
  generating_ideas: "generating_ideas",
  generating_music: "generating_music",
  generating_thumbnail: "generating_thumbnail",
  pending: "pending",
} as const;
